import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppMaterialModule } from "../app.material.module";
import { DataCatalogueRoutingModule } from "./data-catalogue-routing.module";
import { DataCatalogueComponent } from "./data-catalogue.component";
import { FormsModule } from "@angular/forms";
import { Routes } from "@angular/router";
import { DataTypeComponent } from "./data-type/data-type.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  imports: [
    CommonModule,
    DataCatalogueRoutingModule,
    AppMaterialModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],

  declarations: [DataCatalogueComponent],
})
export class DataCatalogueModule {}
